// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__1tNMa","noInteraction":"EventWrapper_noInteraction__2PmHA","pointerPassthrough":"EventWrapper_pointerPassthrough__2yyu7"};